
import React from "react";
import { useTranslation } from "react-i18next";
import { Activity, UserPlus, Calendar, FileEdit, Settings } from "lucide-react";

const RecentActivitiesTab: React.FC = () => {
  const { i18n } = useTranslation();
  const isRTL = i18n.language === "ar";

  const activities = [
    {
      id: 1,
      type: "user",
      title: { ar: "تم إضافة مستخدم جديد", en: "New user added" },
      description: { ar: "قام أحمد بإضافة مستخدم جديد: محمد علي", en: "Ahmed added a new user: Mohammed Ali" },
      time: "10:30",
      icon: UserPlus
    },
    {
      id: 2,
      type: "event",
      title: { ar: "تم إنشاء فعالية جديدة", en: "New event created" },
      description: { ar: "تم إنشاء فعالية جديدة: مهرجان الرياض للتسوق", en: "New event created: Riyadh Shopping Festival" },
      time: "09:15",
      icon: Calendar
    },
    {
      id: 3,
      type: "content",
      title: { ar: "تم تحديث المحتوى", en: "Content updated" },
      description: { ar: "تم تحديث محتوى صفحة الفعاليات", en: "Events page content was updated" },
      time: "08:45",
      icon: FileEdit
    },
    {
      id: 4,
      type: "setting",
      title: { ar: "تغيير الإعدادات", en: "Settings changed" },
      description: { ar: "تم تغيير إعدادات الإشعارات", en: "Notification settings were changed" },
      time: "Yesterday",
      icon: Settings
    }
  ];

  const getIconBgColor = (type: string) => {
    switch(type) {
      case 'user': return 'bg-blue-500/20 text-blue-400';
      case 'event': return 'bg-green-500/20 text-green-400';
      case 'content': return 'bg-purple-500/20 text-purple-400';
      case 'setting': return 'bg-amber-500/20 text-amber-400';
      default: return 'bg-white/10 text-white/60';
    }
  };

  return (
    <div className="space-y-1">
      {activities.length > 0 ? (
        <div className="divide-y divide-white/[0.08]">
          {activities.map((activity) => {
            const IconComponent = activity.icon;
            return (
              <div 
                key={activity.id} 
                className="py-4 first:pt-0 flex items-start hover:bg-white/[0.05] px-3 -mx-3 rounded-lg cursor-pointer transition-colors"
              >
                <div className={`w-10 h-10 rounded-lg flex items-center justify-center shrink-0 ${getIconBgColor(activity.type)}`}>
                  <IconComponent className="h-5 w-5" />
                </div>
                <div className="ml-3 flex-1">
                  <div className="flex items-center justify-between">
                    <h4 className="font-medium text-white">
                      {activity.title[i18n.language as keyof typeof activity.title]}
                    </h4>
                    <span className="text-xs text-white/40">{activity.time}</span>
                  </div>
                  <p className="text-sm text-white/50 mt-1">
                    {activity.description[i18n.language as keyof typeof activity.description]}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <div className="flex flex-col items-center justify-center py-10 text-center">
          <Activity className="h-12 w-12 text-white/20 mb-3" />
          <p className="text-white/60 font-medium">
            {isRTL ? "لا توجد أنشطة حديثة لعرضها" : "No recent activities to display"}
          </p>
          <p className="text-white/40 text-sm mt-1">
            {isRTL ? "ستظهر الأنشطة الحديثة هنا" : "Recent activities will appear here"}
          </p>
        </div>
      )}
      <button className="w-full mt-4 py-2 text-sm text-center text-primary-foreground hover:bg-white/[0.05] rounded-lg transition-colors">
        {isRTL ? "عرض كل الأنشطة" : "View all activities"}
      </button>
    </div>
  );
};

export default RecentActivitiesTab;
